import { config } from '../../../apis/config/config';
const CryptoJS = require('crypto-js');

const environment = process.env.REACT_APP_STAGE

export const encryptData = (data) => {
    var key = CryptoJS.enc.Utf8.parse(config[environment].KEY);
    var iv = CryptoJS.enc.Utf8.parse(config[environment].IV);
    try {
        return {
            data: CryptoJS.AES.encrypt(data, key, { iv: iv }).toString()
        }
        // return JSON.parse(data);

    } catch (error) {
        // 
    }
}

export const decryptData = (data) => {
    var key = CryptoJS.enc.Utf8.parse(config[environment].KEY);
    var iv = CryptoJS.enc.Utf8.parse(config[environment].IV);
    
    try {
        var decryptedWA = CryptoJS.AES.decrypt(data, key, { iv: iv });
        //console.log(decryptedWA.toString(CryptoJS.enc.Utf8),"decryptedWA.toString(CryptoJS.enc.Utf8)");
        
        return decryptedWA.toString(CryptoJS.enc.Utf8)

    } catch (error) {
        // 
    }
}
